// Email Provider Interface
export interface IEmailProvider {
  sendEmail(data: EmailData): Promise<EmailResponse>;
  initialize?(): Promise<void>;
}

export interface EmailData {
  name: string;
  email: string;
  message: string;
  subject?: string;
  recaptchaToken?: string; // Token de reCAPTCHA para validación anti-bot
}

export interface EmailResponse {
  success: boolean;
  message?: string;
  error?: string;
}

export enum EmailProviderType {
  EMAILJS = 'emailjs',
  VERCEL_API = 'vercel',
  CUSTOM_BACKEND = 'custom',
  FORMSPREE = 'formspree',
  WEB3FORMS = 'web3forms'
}
